module.exports = __webpack_public_path__ + "img/16.9.TU.d8d02ef1.png";